<template>
    <Layout>
        <h1 v-bind:class="$style.title">
            404
            <template v-if="resource">
                {{ resource }}
            </template>
            Not Found
        </h1>
    </Layout>
</template>

<script>
    import Layout from '@layouts/main';

    export default {
        /**
         * Custom page meta data property for the view components.
         *
         * @type {Object}
         */
        metaInfo: {
            title: '404',
            meta: [
                {
                    name: 'description',
                    content: '404 - Page Not Found',
                },
            ],
        },

        /**
         * Declaratively register required components.
         *
         * @link https://vuejs.org/v2/guide/components.html#Local-Registration
         */
        components: {
            Layout,
        },

        /**
         * Define the properties passed into the component from the parent.
         *
         * @link https://vuejs.org/v2/guide/components.html#Props
         */
        props: {
            resource: {
                type: String,
                default: '',
            },
        },
    };
</script>

<style lang="scss" module>
    .title {
        @apply text-center;
    }
</style>
